import http from '@utils/http';

const bulletinApi = {
  /**
   * 公告详情
   * @param params
   * @returns {Promise<unknown>}
   */
  detail(params) {
    const headers = {
      accept: 'application/json',
      'Content-Type': 'application/json',
    };
    params = JSON.stringify(params);
    return http
      .post('/workscene/workscene/v1/notice/getDetail', params, headers)
      .then(res => {
        if (res.status === 200) {
          return res.data;
        } else {
          throw res;
        }
      });
  },
  /**
   * 公告签收
   * @param params
   * @returns {Promise<unknown>}
   */
  sign(params) {
    return http
      .get(`/workscene/workscene/v1/announcement/sh/${params.id}/sign`, {
        storeId: params.storeId,
      })
      .then(res => {
        if (res.status === 200) {
          return res.data;
        } else {
          throw res;
        }
      });
  },
};

export default bulletinApi;
